import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ClaimsServiceHandler } from './claims.service.handler';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService extends ClaimsServiceHandler {
  // getOutputPreferences(ref_id: any) {
  //   throw new Error('Method not implemented.');
  // }
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
